import React from 'react';
import { Redirect } from 'react-router-dom';
import { Permissions } from '../../../shared/auth/constants/permissions';
import { useHasPermission } from '../../Session';
import BasicLayout from '../../layouts/BasicLayout';
import { AllBiddingSessions } from '../../pages/DealerBiddings';

const AllBiddingSessionsRoute = () => {
    const canViewCurrentTransactions = useHasPermission(Permissions.SALES_TRANSACTION_VIEW_CURRENT_TRANSACTIONS);

    if (canViewCurrentTransactions) {
        return (
            <BasicLayout>
                <AllBiddingSessions />
            </BasicLayout>
        );
    }

    return <Redirect to="/403" />;
};

export default AllBiddingSessionsRoute;
